import { convertNodeToReactElement } from './convertNodeToReactElement.js';
export function processNodes(nodes, transform) {
    return nodes.map((node, index) => {
        if (transform) {
            const transformed = transform(node, index);
            if (transformed === null || !!transformed) {
                return transformed;
            }
        }
        return convertNodeToReactElement(node, index, transform);
    });
}
//# sourceMappingURL=processNodes.js.map